import { saveAs } from 'file-saver';

export const downloadExcelFile = (data: any, fileName: string) => {
    const weeklyReport = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(weeklyReport, fileName);
};

export const downloadPDFFile = (data: any, fileName: string) => {
    const weeklyReport = new Blob([data], { type: 'application/pdf' });
    saveAs(weeklyReport, fileName);
};

export const downloadDocFile = (data: any, fileName: string) => {
    const weeklyReport = new Blob([data], { type: 'application/msword' });
    saveAs(weeklyReport, fileName);
};

export const downloadDocxFile = (data: any, fileName: string) => {
    const weeklyReport = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    saveAs(weeklyReport, fileName);
};